import React, { useEffect, useState } from "react";
import {
  FaTag,
  FaHome,
  FaArrowRight,
  FaGift,
  FaCar,
  FaPercent,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/Offer.css";

const Offer = () => {
  const navigate = useNavigate();

  const { languageId } = useLanguage();

  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =====================================================
  // GET LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (languageId) {
      return Number(languageId);
    }

    const storedLanguage =
      sessionStorage.getItem("selectedlanguage") ||
      localStorage.getItem("selectedlanguage");

    return Number(storedLanguage) || 1;
  };

  // =====================================================
  // FETCH OFFER CONTENT
  // Legacy PHP:
  //
  // page_id = 18
  // lang_id = selected language
  // =====================================================

  useEffect(() => {
    const fetchOfferContent = async () => {
      try {
        setLoading(true);
        setError("");

        const langId = getLanguageId();

        console.log("====================================");
        console.log("OFFER PAGE");
        console.log("page_id:", 18);
        console.log("lang_id:", langId);
        console.log("====================================");

        const response = await api.get("/contents/content", {
          params: {
            page_id: 18,
            lang_id: langId,
          },
        });

        console.log("OFFER API RESPONSE:", response.data);

        if (
          response.data?.success &&
          response.data?.data
        ) {
          setContent(response.data.data);
        } else {
          setError(
            response.data?.message ||
              "Unable to load offers."
          );
        }
      } catch (err) {
        console.error(
          "OFFER CONTENT ERROR:",
          err
        );

        setError(
          err.response?.data?.message ||
            "Unable to load offers. Please try again."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchOfferContent();
  }, [languageId]);

  // =====================================================
  // NAVIGATION
  // =====================================================

  const goTo = (path) => {
    navigate(path);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {
    return (
      <div className="offer-page">

        <section className="offer-loading">
          <div className="offer-loader"></div>

          <h3>
            Loading offers...
          </h3>

          <p>
            Please wait while we load our latest offers.
          </p>
        </section>

      </div>
    );
  }

  // =====================================================
  // ERROR
  // =====================================================

  if (error) {
    return (
      <div className="offer-page">

        <section className="offer-error-wrapper">

          <div className="offer-error-card">

            <div className="offer-error-icon">
              <FaTag />
            </div>

            <h2>
              Offers unavailable
            </h2>

            <p>
              {error}
            </p>

            <button
              type="button"
              onClick={() =>
                window.location.reload()
              }
              className="offer-primary-btn"
            >
              Try Again
            </button>

          </div>

        </section>

      </div>
    );
  }

  // =====================================================
  // DATA
  // =====================================================

  const title =
    content?.cont_title ||
    "Special Offers";

  const details =
    content?.cont_details ||
    "";

  // =====================================================
  // PAGE
  // =====================================================

  return (
    <div className="offer-page">

      {/* =================================================
          HERO
      ================================================= */}

      <section className="offer-hero">

        <div className="container">

          {/* Breadcrumb */}

          <div className="offer-breadcrumb">

            <span
              className="offer-breadcrumb-home"
              onClick={() => goTo("/")}
            >
              <FaHome />

              <span>
                Home
              </span>
            </span>

            <span className="offer-breadcrumb-slash">
              /
            </span>

            <span>
              {title}
            </span>

          </div>


          {/* Hero Content */}

          <div className="offer-hero-content">

            <div className="offer-hero-icon">
              <FaTag />
            </div>

            <div>

              <div className="offer-small-label">
                <FaPercent />
                SPECIAL DEALS
              </div>

              <h1>
                {title}
              </h1>

              <p>
                Discover our latest car rental
                offers and enjoy more value
                on your journey.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =================================================
          CONTENT
      ================================================= */}

      <main className="offer-main">

        <div className="container">

          <div className="offer-layout">

            {/* Main offer content */}

            <section className="offer-content-card">

              <div className="offer-card-top">

                <div className="offer-card-icon">
                  <FaGift />
                </div>

                <div>

                  <span className="offer-label">
                    EXCLUSIVE OFFERS
                  </span>

                  <h2>
                    {title}
                  </h2>

                </div>

              </div>


              <div
                className="offer-rich-content"
                dangerouslySetInnerHTML={{
                  __html: details,
                }}
              />

            </section>


            {/* Side CTA */}

            <aside className="offer-sidebar">

              <div className="offer-book-card">

                <div className="offer-book-icon">
                  <FaCar />
                </div>

                <span className="offer-book-label">
                  GREAT VALUE
                </span>

                <h3>
                  Find your perfect car
                </h3>

                <p>
                  Check our available cars
                  and book your next journey
                  at the best available rate.
                </p>

                <button
                  type="button"
                  className="offer-book-btn"
                  onClick={() =>
                    goTo("/bookacar")
                  }
                >
                  Book a Car

                  <FaArrowRight />
                </button>

              </div>


              {/* Our Cars */}

              <button
                type="button"
                className="offer-cars-link"
                onClick={() =>
                  goTo("/ourcars")
                }
              >

                <div className="offer-cars-link-icon">
                  <FaCar />
                </div>

                <div className="offer-cars-link-text">

                  <strong>
                    Explore Our Cars
                  </strong>

                  <span>
                    View our fleet
                  </span>

                </div>

                <FaArrowRight />

              </button>

            </aside>

          </div>


          {/* =================================================
              BOTTOM CTA
          ================================================= */}

          <section className="offer-bottom-cta">

            <div className="offer-bottom-icon">
              <FaTag />
            </div>

            <div className="offer-bottom-text">

              <h3>
                Don't miss our special offers
              </h3>

              <p>
                Choose your dates and find
                the right car for your trip.
              </p>

            </div>

            <button
              type="button"
              onClick={() =>
                goTo("/ourcars")
              }
              className="offer-bottom-btn"
            >
              View Cars

              <FaArrowRight />
            </button>

          </section>

        </div>

      </main>

    </div>
  );
};

export default Offer;